import { useColorModeValue } from '@chakra-ui/react';
import { ChakraComponents } from '@Modules/core/lib/chakra';
import React from 'react';

type Props = {
  children: React.ReactNode,
};

export default function CustomCard({ children }: Props) {
  return (
    <>
      <ChakraComponents.Box bg={useColorModeValue('white', 'gray.800')} p="5">
        {children}
      </ChakraComponents.Box>
    </>
  );
}
